// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__1IpVT","actionsCol":"EnrolledClinics_actionsCol__1urTj"};